import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/404",
    component: () => import("@/views/error/404.vue"),
  },
  {
    path: "/workflow/disposeForMiniProgram",
    component: () => import("@/views/workflow/pages/disposeForMiniProgram.vue"),
  },
  {
    path: "/workflow/view",
    component: () => import("@/views/workflow/pages/view.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
